import { lazy } from 'react';

const CertifiedNomineesConsultPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}

	},
	routes: [
		{
			path: '/certificates/consult/nominees',
			component: lazy(() => import('./CertifiedNomineesPage'))
		}
	]
};

export default CertifiedNomineesConsultPageConfig;